import Avatar from './src/Avatar';

export default Avatar;
